import { setConnectCarrierHeaders } from '@app/client';
import { useFormatTenantID } from '@connect-carrier/hooks/useFormatTenantID';
// ts-unused-exports:disable-next-line
export const useAuthHeader = (companyId: string, tenantId: string): void => {
  const headers: anyOk = {};
  if (companyId) {
    headers['Company-Id'] = companyId;
  }
  const formatTenantID = useFormatTenantID(tenantId);
  if (formatTenantID) {
    headers['Tenant-Id'] = formatTenantID;
  }
  setConnectCarrierHeaders(headers);
};
